import React, { useEffect, useState } from 'react';
import { prop } from 'js/utils/ramda.util';
import { useDeviceSelector } from 'js/store/hooks';
import { useComponentConfig } from 'js/hooks/component/useComponentConfig';

import * as hooks from '../../hooks';
import * as helpers from '../../helpers';
import { TableItem } from './components/TableItem';
import { TABLE_ANIMATION_INTERVAL, TABLE_ITEM_HEIGHT } from '../../constants';

import style from './Table.scss';

export const Table = () => {
    const { rowsAmount = 3 } = useComponentConfig();
    const isDesktop = useDeviceSelector(prop('isDesktop'));
    const allWinners = hooks.useTopWinners();
    const [topWinners, setTopWinners] = useState(helpers.getWinnersSelection({
        rowsAmount, startIndex: 0, allWinners
    }));

    useEffect(() => {
        if (!rowsAmount) {
            return;
        }

        let startIndex = 1;

        const intervalId = setInterval(() => {
            const winners = helpers.getWinnersSelection({
                rowsAmount, startIndex, allWinners
            });

            setTopWinners(winners);
            startIndex++;
        }, TABLE_ANIMATION_INTERVAL);

        return () => clearInterval(intervalId);
    }, [allWinners, rowsAmount]);

    const componentHeight = topWinners.length * (isDesktop ? TABLE_ITEM_HEIGHT.DESKTOP : TABLE_ITEM_HEIGHT.MOBILE);

    return (
        <div className={style.tableWrapper} style={{ minHeight: `${componentHeight}rem` }}>
            {topWinners.map(topWinner => (
                <TableItem
                    {...topWinner}
                    key={topWinner.id}
                    className={style.topWinner}
                />
            ))}
        </div>
    );
};
